module.exports = __webpack_public_path__ + "assets/refresh-icon.svg";